const auditActorTypeValues = ['user', 'system', 'contact'];
export const AuditActorType = {
    USER: auditActorTypeValues[0],
    SYSTEM: auditActorTypeValues[1],
    CONTACT: auditActorTypeValues[2],
};
export const AuditActorTypeValues = auditActorTypeValues;
//# sourceMappingURL=AuditActorType.js.map